import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import Landing from "./container/Landing";
import NoMatch from "./container/NoMatch";

class App extends Component {
  state = {
    lang: "en"
  };

  render() {
    return (
      <Switch>
        <Route exact path="/" render={props => <Landing />} />
        {/* <Route component={NoMatch} /> */}
      </Switch>
    );
  }
}

export default App;
